import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client'; // Updated to use createRoot for React 18+
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SideBarProvider, AuthProvider, AlertProvider } from './providers';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container); // Use createRoot instead of render
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <AlertProvider>
          <SideBarProvider>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </SideBarProvider>
        </AlertProvider>
      </AuthProvider>
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
